module.exports = __webpack_public_path__ + "static/media/Subramani E.160e8fca.png";